import {
    Accordion,
    ACCORDION_BASE_CLASSNAME,
    createAccordionComponent,
} from '@vfde-brix/accordion';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

/**
 * Accordion component
 * @param container
 * @param properties
 */
const mountAccordion = (container: HTMLElement, properties = {}): Accordion => {
    return createAccordionComponent(container, properties);
};

/**
 * Mount all other editorial accordions
 */
export const mountEditorialAccordions = (excludes: string[]) => {
    const elements = document.getElementsByClassName(ACCORDION_BASE_CLASSNAME);

    for (let i = 0, x = elements.length; i < x; i += 1) {
        const containerElement = elements[i].parentNode as HTMLElement;
        if (excludes.indexOf(containerElement.id) === -1) {
            mountAccordion(containerElement, NO_PATTERN_BUSINESS_LOGIC);
        }
    }
};

export default mountAccordion;
